import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function WhyChooseSection() {
  const benefits = [
  {
    id: 'benefit_network',
    icon: 'GlobeAltIcon',
    title: 'Global Network',
    description: 'We work with over 5,000 trusted partners in 25+ countries. Our supply chains are reliable, efficient, and built on years of strong relationships.',
    stat: '5,000+',
    statLabel: 'Active Partners'
  },
  {
    id: 'benefit_quality',
    icon: 'ShieldCheckIcon',
    title: 'Quality Guaranteed',
    description: 'Every product is ISO certified. We check quality at every stage, so you always get exactly what you ordered.',
    stat: 'ISO',
    statLabel: 'Certified'
  },
  {
    id: 'benefit_pricing',
    icon: 'CurrencyDollarIcon',
    title: 'Competitive Pricing',
    description: 'Get the best bulk rates with flexible payment terms. Volume discounts available. We help you save money without compromising quality.',
    stat: '30%',
    statLabel: 'Average Savings'
  },
  {
    id: 'benefit_delivery',
    icon: 'TruckIcon',
    title: 'Fast Delivery',
    description: 'We ship worldwide with tracked logistics. On-time delivery guaranteed. Your order arrives when you need it.',
    stat: '98%',
    statLabel: 'On-Time Rate'
  }];


  return (
    <section className="py-24 bg-muted">
      <div className="max-w-container mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          {/* Left: Image with Floating Stats */}
          <div className="lg:col-span-5 reveal">
            <div className="relative">
              <div className="rounded-organic-lg overflow-hidden shadow-xl">
                <AppImage
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_11a7b5499-1769540765171.png"
                  alt="Modern warehouse facility with organized inventory showing SDSA operations"
                  className="w-full h-[500px] object-cover" />
                
              </div>

              {/* Floating Stat Card 1 */}
              <div className="absolute top-8 -right-8 bg-white rounded-organic p-6 shadow-2xl max-w-xs hover-lift">
                <div className="text-4xl font-bold font-serif text-primary mb-1">50,000+</div>
                <div className="text-sm text-muted-foreground">Tons Delivered Annually</div>
              </div>

              {/* Floating Stat Card 2 */}
              <div className="absolute bottom-8 -left-8 bg-primary text-primary-foreground rounded-organic p-6 shadow-2xl max-w-xs hover-lift">
                <div className="text-4xl font-bold font-serif mb-1">25+</div>
                <div className="text-sm opacity-90">Years of Excellence</div>
              </div>
            </div>
          </div>

          {/* Right: Benefits */}
          <div className="lg:col-span-7">
            <div className="mb-12 reveal">
              <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary mb-4">
                Why Choose SDSA
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-6">
                Why Businesses Choose SDSA
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Since 2001, we've built a reputation for reliability, quality, and exceptional service. Over two decades of experience means you can trust us to deliver every time.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {benefits.map((benefit, index) =>
              <div
                key={benefit.id}
                className="reveal"
                style={{ transitionDelay: `${index * 100}ms` }}>
                
                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
                      <Icon name={benefit.icon as any} size={24} className="text-primary" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold font-serif text-foreground mb-2">
                        {benefit.title}
                      </h3>
                      <p className="text-sm text-muted-foreground mb-3 leading-relaxed">
                        {benefit.description}
                      </p>
                      <div className="inline-flex items-baseline gap-2">
                        <span className="text-2xl font-bold text-primary">{benefit.stat}</span>
                        <span className="text-xs text-muted-foreground uppercase tracking-wider">
                          {benefit.statLabel}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

}